import { createLegacyEnvConfig, Environment, ServicesOrchestrator } from "@pandas/constants";
import { z } from "zod";

export const appEnvSchema = z.object({
	VITE_APP_NAME: z.string().default("webapp"),
	VITE_APP_VERSION: z.string().default("0.0.0"),
	VITE_APP_ENV: z.enum(Environment).optional(),
	VITE_SIMPLELOCALIZE_PROJECT_TOKEN: z.string(),
	VITE_SIMPLELOCALIZE_ENV: z.string(),
});

const commonEnv = createLegacyEnvConfig(import.meta.env);
const appEnv = appEnvSchema.parse(import.meta.env);

const orchestrator = new ServicesOrchestrator({ env: commonEnv });

export const servicesOrchestratorValues = {
	app: {
		name: appEnv.VITE_APP_NAME,
		version: appEnv.VITE_APP_VERSION,
		env: appEnv.VITE_APP_ENV ?? commonEnv.COMMON_ENV_ENVIRONMENT,
	},
	environment: orchestrator.environment,
	isProduction: orchestrator.isProduction,
	isUat: orchestrator.isUat,
	isDevelopment: orchestrator.isDevelopment,
	urls: orchestrator.urls,
	credentials: {
		...orchestrator.credentials,
		ablyKey: commonEnv.COMMON_ENV_ABLY_API_KEY,
		posthogKey: commonEnv.COMMON_ENV_POSTHOG_KEY,
		posthogHost: commonEnv.COMMON_ENV_POSTHOG_HOST,
		simpleLocalizeProjectToken: appEnv.VITE_SIMPLELOCALIZE_PROJECT_TOKEN,
		simpleLocalizeEnvironment: appEnv.VITE_SIMPLELOCALIZE_ENV,
	},
} as const;
